"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorContent = exports.ErrorView = exports.StyledCenterView = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
exports.StyledCenterView = styled_components_1.default.div `
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
  .content {
    padding: 20px;
    text-align: center;
    .icon,
    .MuiSvgIcon-root {
      font-size: 180px;
    }
  }
  &::before {
    content: '';
    flex: 1 1 45%;
  }
  &::after {
    content: '';
    flex: 1 1 55%;
  }
`;
const StyledContent = styled_components_1.default.div `
  padding: 20px;
  text-align: center;
  .icon,
  .MuiSvgIcon-root {
    font-size: 180px;
  }
`;
const ErrorView = props => {
    const { className } = props, contentProps = __rest(props, ["className"]);
    return (react_1.default.createElement(exports.StyledCenterView, { className: className },
        react_1.default.createElement(exports.ErrorContent, Object.assign({}, contentProps))));
};
exports.ErrorView = ErrorView;
const ErrorContent = props => {
    const { title, description, icon, className = '' } = props;
    return (react_1.default.createElement(StyledContent, { className: `content ${className}` },
        icon && react_1.default.createElement(core_1.Box, { mb: 1 }, icon),
        react_1.default.createElement(core_1.Box, { mb: 1 }, typeof title !== 'string' ? (title) : (react_1.default.createElement(core_1.Typography, { variant: 'h4' }, title))),
        react_1.default.createElement(core_1.Box, { mb: 4 }, typeof description !== 'string' ? (description) : (react_1.default.createElement(core_1.Typography, { variant: 'body1', color: 'textSecondary' }, description)))));
};
exports.ErrorContent = ErrorContent;
exports.default = exports.ErrorView;
//# sourceMappingURL=ErrorView.js.map